import axios from "axios";
import { VriAPIResponse, VriAPIResult } from "../types";
import END_POINT from "../config/endpoints.constants";
import * as Sentry from "@sentry/react";

export interface FeatureFlagRequestPayload {
  flagName: string;
  data?: {
    [key: string]: any;
  }
}

export interface FeatureFlagResult extends VriAPIResult {
  isEnabled: boolean | null;
}

export interface FeatureFlagResponse extends VriAPIResponse {
  data?: {
    flagStatus: boolean | null;
  };
}

export const getFeatureFlag = async (payload: FeatureFlagRequestPayload) => {
  const result = {} as FeatureFlagResult;

  try {
    const { data: responseData } = await axios.post<FeatureFlagResponse>(
      END_POINT.FEATURE_FLAG,
      payload
    );
    if (responseData) {
      if (responseData.code === 0) {
        result.isEnabled = responseData.data?.flagStatus || null;
      } else {
        result.error = responseData.message;
      }
    }
  } catch (error) {
    result.error = error;
    Sentry.captureException(error, {
      tags: { activity: "getFeatureFlag", flagName: payload.flagName },
      extra: { payload },
    });
  }
  return result;
};
